/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Ticker_Mode_PrefixInputs */

const bn_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মোড`)
};

const de_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MODUS`)
};

const el_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΤΡΟΠΟΣ`)
};

const en_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MODE`)
};

const es_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MODO`)
};

const fr_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MODE`)
};

const hi_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तरीका`)
};

const hu_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MÓD`)
};

const id_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MODE`)
};

const it_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MODALITÀ`)
};

const ja_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モード`)
};

const ko_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방법`)
};

const nl_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MODUS`)
};

const pl_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRYB`)
};

const pt_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MODO`)
};

const ru_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`РЕЖИМ`)
};

const sv_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LÄGE`)
};

const tr_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MOD`)
};

const uk_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`РЕЖИМ`)
};

const vi_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CÁCH THỨC`)
};

const zh_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模式`)
};

const zh_hant_cipher_ticker_mode_prefix = /** @type {(inputs: Cipher_Ticker_Mode_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模式`)
};

/**
* | output |
* | --- |
* | "MODE" |
*
* @param {Cipher_Ticker_Mode_PrefixInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_ticker_mode_prefix = /** @type {((inputs?: Cipher_Ticker_Mode_PrefixInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Ticker_Mode_PrefixInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_ticker_mode_prefix(inputs)
	if (locale === "de") return de_cipher_ticker_mode_prefix(inputs)
	if (locale === "el") return el_cipher_ticker_mode_prefix(inputs)
	if (locale === "en") return en_cipher_ticker_mode_prefix(inputs)
	if (locale === "es") return es_cipher_ticker_mode_prefix(inputs)
	if (locale === "fr") return fr_cipher_ticker_mode_prefix(inputs)
	if (locale === "hi") return hi_cipher_ticker_mode_prefix(inputs)
	if (locale === "hu") return hu_cipher_ticker_mode_prefix(inputs)
	if (locale === "id") return id_cipher_ticker_mode_prefix(inputs)
	if (locale === "it") return it_cipher_ticker_mode_prefix(inputs)
	if (locale === "ja") return ja_cipher_ticker_mode_prefix(inputs)
	if (locale === "ko") return ko_cipher_ticker_mode_prefix(inputs)
	if (locale === "nl") return nl_cipher_ticker_mode_prefix(inputs)
	if (locale === "pl") return pl_cipher_ticker_mode_prefix(inputs)
	if (locale === "pt") return pt_cipher_ticker_mode_prefix(inputs)
	if (locale === "ru") return ru_cipher_ticker_mode_prefix(inputs)
	if (locale === "sv") return sv_cipher_ticker_mode_prefix(inputs)
	if (locale === "tr") return tr_cipher_ticker_mode_prefix(inputs)
	if (locale === "uk") return uk_cipher_ticker_mode_prefix(inputs)
	if (locale === "vi") return vi_cipher_ticker_mode_prefix(inputs)
	if (locale === "zh") return zh_cipher_ticker_mode_prefix(inputs)
	return zh_hant_cipher_ticker_mode_prefix(inputs)
});